"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
// @ts-ignore
var store_1 = __importDefault(require("@/store"));
var ant_design_vue_1 = require("ant-design-vue");
var ISSOConfig_1 = require("./ISSOConfig");
// @ts-ignore
var authUtils_1 = require("../utils/authUtils");
var RouterConfig = /** @class */ (function () {
    function RouterConfig(params) {
        this.router = params.router;
        this.axios = params.axios;
        this.APPID = params.APPID;
        this.SYSTEM = params.SYSTEM;
        if (params.beforeEach) {
            this.beforeEach = params.beforeEach;
        }
    }
    RouterConfig.prototype.setRouter = function (_router) {
        this.router = _router;
    };
    RouterConfig.prototype.checkIfAUZValid = function (authorization, userId) {
        if (!userId || !authorization || authorization.split('.').length < 3) {
            return false;
        }
        try {
            var jwt = authorization.split('.')[1];
            var _a = JSON.parse(window.atob(jwt) || '{}'), exp = _a.exp, info = _a.jwt_info;
            if (!info || !info.system_code || !info.user_id
                || info.system_code != this.SYSTEM || info.user_id != userId) {
                return false;
            }
            // token剩余有效期少于1天，重新获取最新token
            if (new Date().getTime() + 24 * 60 * 60 * 1000 > exp * 1000) {
                return false;
            }
            return true;
        }
        catch (e) {
            return false;
        }
    };
    RouterConfig.prototype.routerAuth = function (to, from, next) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var userBeforeEach, expires, domain, topLevel, params4bizToken, authorization, userId, accountToken, result, status_1, response, buttons;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        userBeforeEach = this.beforeEach && this.beforeEach(to, from, next);
                        if (userBeforeEach === false) {
                            next();
                            return [2 /*return*/];
                        }
                        expires = js_cookie_1.default.get("remeber") == "1" ? 30 : 3;
                        domain = document.domain != 'localhost' ? document.domain : 'localhost';
                        topLevel = domain != 'localhost' ? Array(1).concat(document.domain.split('.').slice(-2)).join('.') : '';
                        params4bizToken = { "system_code": this.SYSTEM };
                        authorization = js_cookie_1.default.get(ISSOConfig_1.ETokenName.authorizationKey);
                        userId = js_cookie_1.default.get("userid");
                        accountToken = js_cookie_1.default.get(ISSOConfig_1.ETokenName.accountTokenKey);
                        if (!!!to.query.auth_token) return [3 /*break*/, 2];
                        //从登陆页面跳回来,如果acctoken，userid，loginname三个字段已经存在了，那么就不会重复写入cookie
                        //此处写入的cookie生命周期与浏览器页面存在时间一致
                        if (js_cookie_1.default.get(ISSOConfig_1.ETokenName.accountTokenKey) == "" || !js_cookie_1.default.get(ISSOConfig_1.ETokenName.accountTokenKey)) {
                            js_cookie_1.default.set(ISSOConfig_1.ETokenName.accountTokenKey, "".concat(to.query.auth_token), { expires: expires, domain: domain });
                        }
                        if (!!this.checkIfAUZValid(authorization, userId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.axios.get("".concat(process.env.VUE_APP_SSO_API_ADDRESS, "/auth/verify"), params4bizToken)];
                    case 1:
                        result = _c.sent();
                        status_1 = result.status, response = result.data;
                        if (status_1 === 200 && (response === null || response === void 0 ? void 0 : response.code) === 0) {
                            // 清除顶级域名残留cookie的影响
                            !!topLevel ? js_cookie_1.default.remove(ISSOConfig_1.ETokenName.authorizationKey, { domain: topLevel }) : '';
                            !!topLevel ? js_cookie_1.default.remove(ISSOConfig_1.ETokenName.accountTokenKey, { domain: topLevel }) : '';
                            // Cookies.set(ETokenName.authorizationKey, response.data.business_token, { domain });
                            // localStorage.setItem(ETokenName.authorizationKey, response.data.business_token);
                            js_cookie_1.default.set(ISSOConfig_1.ETokenName.authorizationKey, to.query.auth_token.toString(), { domain: domain });
                            localStorage.setItem(ISSOConfig_1.ETokenName.authorizationKey, to.query.auth_token.toString());
                            buttons = (response.data.user_profile.buttons || []).map(function (item) { return item.name; }) || [];
                            try {
                                localStorage.setItem("-USER-SETTINGS", JSON.stringify(response.data));
                                localStorage.setItem("-USER-BUTTON-PERMISSIONS", JSON.stringify(buttons));
                                store_1.default.commit("account", (_b = (_a = response.data.user_profile) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.real_name);
                            }
                            catch (err) { }
                        }
                        else {
                            ant_design_vue_1.message.error(response === null || response === void 0 ? void 0 : response.message);
                            setTimeout(function () { return (0, authUtils_1.logout)(); }, 250);
                            // // without accountTokenKey and authorizationKey, api response will guide to login ...
                            // Cookies.remove(ETokenName.accountTokenKey);
                            // // 清除顶级域名残留cookie的影响
                            // !!topLevel ? Cookies.remove(ETokenName.authorizationKey, {domain: topLevel}) : '';
                            // !!topLevel ? Cookies.remove(ETokenName.accountTokenKey, {domain: topLevel}) : '';
                            // Cookies.remove(ETokenName.authorizationKey);
                            // Cookies.remove(ETokenName.authorizationKey, {domain});
                            // localStorage.removeItem('usToken');
                            // setTimeout(() => {
                            //     window.location.reload();
                            // }, 500)
                        }
                        _c.label = 2;
                    case 2:
                        next();
                        return [2 /*return*/];
                }
            });
        });
    };
    return RouterConfig;
}());
exports.default = RouterConfig;
